<template>
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Specialist Details</p>
    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.effect"
            id="effect"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="effect"
            >Effect</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.delay"
            id="delay"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="delay"
            >Delay</label
          >
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.damage_dice"
            id="damage_dice"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="damage_dice"
            >Damage Dice</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.duration"
            id="duration"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="duration"
            >Duration</label
          >
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col-6 form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.resist"
            id="resist"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="resist"
            >Resist</label
          >
        </div>
      </div>
    </div>

    <div v-if="activeItem.countable">
      <div class="row mt-2 mb-2"></div>
      <p class="bb-sub-hdg mb-2 mt-2">Unit Details</p>

      <div class="row mt-2 mb-2">
        <div class="col-5 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="displayUnitName"
              id="unit_name"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="unit_name"
              >Unit Name</label
            >
          </div>
        </div>
        <div class="col-3 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="activeItem.tally_qty"
              id="tally_qty"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="tally_qty"
              >Tally Qty</label
            >
          </div>
        </div>
      </div>

      <div class="row mt-2 mb-2"></div>
      <div
        v-if="activeItem.tally_qty > 0"
        class="row mt-2 mb-2"
      >
        <p class="bb-sub-hdg">Current {{ localItem.name }}</p>
        <div class="col-5 form-group">
          <CounterEmit
            ref="maxUnitCounter"
            :pass_ref="'max_unit_count'"
            :pass_label="`Max ${displayUnitName}s`"
            :pass_count="localItem.max_unit_count"
            :pass_min="1"
            :pass_max="100"
            :pass_digits="2"
            @change="onCounterChanged"
          />
        </div>
        <div
          v-if="showCurUnitCount"
          class="col-5 form-group"
        >
          <CounterEmit
            ref="curUnitCounter"
            :pass_ref="'cur_unit_count'"
            :pass_label="`Cur ${displayUnitName}s`"
            :pass_count="localItem.cur_unit_count"
            :pass_min="0"
            :pass_max="localItem.max_unit_count"
            :pass_digits="2"
            @change="onCounterChanged"
          />
        </div>
      </div>

      <div
        v-else
        class="row mt-2 mb-2"
      >
        <div class="col-5 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="activeItem.max_unit_count"
              id="max_unit_count"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="max_unit_count"
              >Max Unit Count</label
            >
          </div>
        </div>
        <div class="col-5 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="activeItem.cur_unit_count"
              id="cur_unit_count"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="cur_unit_count"
              >Cur Unit Count</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CounterEmit from './CounterEmit.vue'

export default {
  name: 'ArtefactSpecialistTab',
  components: {
    CounterEmit,
  },
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      required: true,
    },
    onCounterChanged: {
      type: Function,
      required: true,
    },
    showCurUnitCount: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    displayUnitName() {
      return this.localItem?.unit_name || this.activeItem?.unit_name || ''
    },
  },
}
</script>
